import Analytics from "@web-solutions/module-analytics";

export const emitApplePayButtonClick = (args?: Record<string, any>) => {

  const appleButton = (document.querySelector('apple-pay-button') || document.querySelector('#apple-pay') || document.querySelector('button[label="apple"]')) as HTMLButtonElement | null;

  if (appleButton) {
    try {
      appleButton.click();

    } catch (error) {
      throw error;
    }
    Analytics.trackEvent('apple_pay_emit', 'click', args);
  } else {
    throw Error('Apple Pay button not found');
  }

}

export const emitGooglePayButtonClick = (args?: Record<string, any>) => {

  const googleButton = document.querySelector<HTMLButtonElement>('[aria-label="Google Pay"]');

  if (googleButton) {
    try {
      googleButton.click();
    } catch (error) {
      throw error;
    }
    Analytics.trackEvent('google_pay_emit', 'click', args);
  } else {
    throw Error('Google Pay button not found');
  }
}